// Firebasehome
import React, { useEffect, useState, useRef } from "react";

import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/jsvectormap.min.css";
import { Card, CardBody } from "./../../../components/card/card.jsx";
// import Chart from "react-apexcharts";
import Chart from "chart.js/auto";
import Select from "react-select";

import DateRangePicker from "react-bootstrap-daterangepicker";

import "bootstrap-daterangepicker/daterangepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";

import {
  dateOptions,
  AgeOptions,
  GAUserOptions,
  GADateOptions,
  GAEcommerceOptions,
  GAEventOptions,
  GARevenueOptions,
  GASessionOptions,
  GAPageScreenOptions,
} from "./../../../components/selectvalues/selectvalue.jsx";

import { ModalComponent } from "./../../expand/expandmodal.jsx";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider.js";

const Firebasehome = () => {
  const mainChartRef = useRef(null);
  const ecommerceChartRef = useRef(null);
  const revenueChartRef = useRef(null);
  const eventChartRef = useRef(null);
  const pagescreenChartRef = useRef(null);
  const sessionChartRef = useRef(null);

  const [UserTile, setDataUserTile] = useState([]);
  const [EcommerceTile, setDataEcommerceTile] = useState([]);
  const [RevenueTile, setDataRevenueTile] = useState([]);
  const [EventTile, setDataEventTile] = useState([]);
  const [PageScreenTile, setDataPageScreenTile] = useState([]);
  const [SessionTile, setDataSessionTile] = useState([]);

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [dimension, setDimension] = useState("");
  const [metric, setMetric] = useState("");
  const [agestart, setAgeStart] = useState("");
  const [ageend, setAgeEnd] = useState("");
  const [data, setData] = useState(null);

  // =========================================================
  // LOADER HELPERS (same pattern as Webflow realtime / GAHomeMain)
  // =========================================================
  const uiThemeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  const uiInverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  const uiInverseRgb = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse-rgb")
    .trim();

  const InlineSpinner = ({ size = 26 }) => (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          border: `3px solid rgba(${uiInverseRgb},0.15)`,
          borderTop: `3px solid ${uiThemeColor}`,
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );

  const NoData = ({ text }) => (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: uiInverse,
        opacity: 0.6,
        fontSize: 13,
        padding: 12,
      }}
    >
      {text}
    </div>
  );

  const RefreshNote = () => (
    <div style={{ color: uiThemeColor, fontSize: 12, textAlign: "center" }}>
      Refreshing…
    </div>
  );

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0)",
    pointerEvents: "none",
  };

  // Initial load flags
  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingEcommerce, setLoadingEcommerce] = useState(true);
  const [loadingRevenue, setLoadingRevenue] = useState(true);
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [loadingPageScreen, setLoadingPageScreen] = useState(true);
  const [loadingSession, setLoadingSession] = useState(true);

  // Refresh flags (subsequent fetches; keep chart visible)
  const [refreshingUser, setRefreshingUser] = useState(false);
  const [refreshingEcommerce, setRefreshingEcommerce] = useState(false);
  const [refreshingRevenue, setRefreshingRevenue] = useState(false);
  const [refreshingEvent, setRefreshingEvent] = useState(false);
  const [refreshingPageScreen, setRefreshingPageScreen] = useState(false);
  const [refreshingSession, setRefreshingSession] = useState(false);

  // Track first successful load per tile
  const userHasLoaded = useRef(false);
  const ecommerceHasLoaded = useRef(false);
  const revenueHasLoaded = useRef(false);
  const eventHasLoaded = useRef(false);
  const pagescreenHasLoaded = useRef(false);
  const sessionHasLoaded = useRef(false);

  // color & font variable
  var gray300Color = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-300")
    .trim();
  var gray300RgbColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-300-rgb")
    .trim();
  var indigoColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-indigo")
    .trim();
  var bodyColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-color")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();
  var borderColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-border-color")
    .trim();
  var bodyFontFamily = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-family")
    .trim();
  var bodyFontWeight = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-weight")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();

  // chart global options
  Chart.defaults.font.family = bodyFontFamily;
  Chart.defaults.font.size = 12;
  Chart.defaults.color = bodyColor;
  Chart.defaults.borderColor = borderColor;
  Chart.defaults.plugins.legend.display = false;
  Chart.defaults.plugins.tooltip.padding = {
    left: 8,
    right: 12,
    top: 8,
    bottom: 8,
  };
  Chart.defaults.plugins.tooltip.cornerRadius = 8;
  Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
  Chart.defaults.plugins.tooltip.color = bodyBg;
  Chart.defaults.plugins.tooltip.multiKeyBackground = inverse;
  Chart.defaults.plugins.tooltip.backgroundColor = "black";
  Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
  Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
  Chart.defaults.plugins.tooltip.footerFont.family = bodyFontFamily;
  Chart.defaults.plugins.tooltip.displayColors = true;
  Chart.defaults.plugins.tooltip.boxPadding = 6;
  Chart.defaults.scale.grid.color = borderColor;
  Chart.defaults.scale.beginAtZero = true;

  var themeFont = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-family")
    .trim();
  var themeFontWeight = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-font-weight")
    .trim();
  var gray500 = getComputedStyle(document.body)
    .getPropertyValue("--bs-gray-500")
    .trim();
  var orange = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse2 = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var inverseRgb = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse-rgb")
    .trim();
  var borderColor2 = getComputedStyle(document.body)
    .getPropertyValue("--bs-border-color")
    .trim();
  var indigo = getComputedStyle(document.body)
    .getPropertyValue("--bs-indigo")
    .trim();

  //gauserTile
  const [customDateRange, setgauserCustomDateRange] = useState(false);
  const [gauserstartDate, setgauserStartDate] = useState();
  const [gauserendDate, setgauserEndDate] = useState();

  const [gauserselectedDateOption, setgauserSelectedDateOption] = useState(
    GADateOptions[4]
  );
  const [gauserselectedOption, setgauserSelectedOption] = useState(
    GAUserOptions[0]
  );
  const [gaselectedDateOption, setgaselectedDateOption] = useState();

  const [craftedcustomDateRange, setcraftedCustomDateRange] = useState(false);
  const [craftedstartDate, setcraftedStartDate] = useState(new Date());
  const [craftedendDate, setcraftedEndDate] = useState(new Date());

  //gaecommerceTile
  const [gaecommerceselectedDateOption, setgaecommerceSelectedDateOption] =
    useState(GADateOptions[4]);
  const [gaecommerceselectedOption, setgaecommerceSelectedOption] = useState(
    GAEcommerceOptions[2]
  );

  //garevenueTile
  const [garevenueselectedDateOption, setgarevenueSelectedDateOption] =
    useState(GADateOptions[4]);
  const [garevenueselectedOption, setgarevenueSelectedOption] = useState(
    GARevenueOptions[5]
  );

  //gaeventTile
  const [gaeventselectedDateOption, setgaeventSelectedDateOption] = useState(
    GADateOptions[4]
  );
  const [gaeventselectedOption, setgaeventSelectedOption] = useState(
    GAEventOptions[1]
  );

  //gapagescreenTile
  const [gapagescreenselectedDateOption, setgapagescreenSelectedDateOption] =
    useState(GADateOptions[4]);
  const [gapagescreenselectedOption, setgapagescreenSelectedOption] = useState(
    GAPageScreenOptions[0]
  );

  //gasessionTile
  const [gasessionselectedDateOption, setgasessionSelectedDateOption] =
    useState(GADateOptions[4]);
  const [gasessionselectedOption, setgasessionSelectedOption] = useState(
    GASessionOptions[6]
  );

  const handlegauserdateChange = (selectedOption) => {
    setgauserSelectedDateOption(selectedOption);
  };
  const handlegauserChange = (selectedOption) => {
    setgauserSelectedOption(selectedOption);
  };

  const handlegaecommercedateChange = (selectedOption) => {
    setgaecommerceSelectedDateOption(selectedOption);
  };
  const handlegaecommerceChange = (selectedOption) => {
    setgaecommerceSelectedOption(selectedOption);
  };

  const handlegarevenuedateChange = (selectedOption) => {
    setgarevenueSelectedDateOption(selectedOption);
  };
  const handlegarevenueChange = (selectedOption) => {
    setgarevenueSelectedOption(selectedOption);
  };

  const handlegaeventdateChange = (selectedOption) => {
    setgaeventSelectedDateOption(selectedOption);
  };
  const handlegaeventChange = (selectedOption) => {
    setgaeventSelectedOption(selectedOption);
  };

  const handlegapagescreendateChange = (selectedOption) => {
    setgapagescreenSelectedDateOption(selectedOption);
  };
  const handlegapagescreenChange = (selectedOption) => {
    setgapagescreenSelectedOption(selectedOption);
  };

  const handlegasessiondateChange = (selectedOption) => {
    setgasessionSelectedDateOption(selectedOption);
  };
  const handlegasessionChange = (selectedOption) => {
    setgasessionSelectedOption(selectedOption);
  };

  const craftedlabels = UserTile.dailyData
    ? UserTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const craftedlinevalues = UserTile.dailyData
    ? UserTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  const ecommercelabels = EcommerceTile.dailyData
    ? EcommerceTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const ecommercelinevalues = EcommerceTile.dailyData
    ? EcommerceTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  const revenuelabels = RevenueTile.dailyData
    ? RevenueTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const revenuelinevalues = RevenueTile.dailyData
    ? RevenueTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  const eventlabels = EventTile.dailyData
    ? EventTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const eventlinevalues = EventTile.dailyData
    ? EventTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  const pagescreenlabels = PageScreenTile.dailyData
    ? PageScreenTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const pagescreenlinevalues = PageScreenTile.dailyData
    ? PageScreenTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  const sessionlabels = SessionTile.dailyData
    ? SessionTile.dailyData.map((item) => item.dimensionValues[0].value)
    : [];
  const sessionlinevalues = SessionTile.dailyData
    ? SessionTile.dailyData.map((item) => item.metricValues[0].value)
    : [];

  var CraftedChartData = [{ name: "Users", data: craftedlinevalues }];

  var CraftedChartOptions = {
    chart: {
      shadow: {
        enabled: true,
        color: "rgba(" + inverseRgb + ", .5)",
        top: 18,
        left: 7,
        blur: 10,
        opacity: 1,
      },
      toolline: { show: true },
    },
    title: {
      text: "",
      align: "center",
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        fontFamily: themeFont,
        color: inverse2,
      },
    },
    colors: ["#96E2E3", gray500],
    dataLabels: {
      enabled: false,
      background: {
        enabled: true,
        padding: 4,
        borderRadius: 2,
        borderWidth: 0,
        opacity: 0.9,
        dropShadow: { enabled: false },
      },
    },
    stroke: { curve: "straight", width: 4 },
    markers: { size: 6 },
    xaxis: {
      categories: craftedlabels,
      axisBorder: {
        show: true,
        color: "rgba(" + inverseRgb + ", .25)",
        height: 1,
        width: "100%",
        offsetX: 0,
        offsetY: -1,
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "rgba(" + inverseRgb + ", .25)",
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        style: {
          colors: inverse2,
          fontSize: "12px",
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: inverse2,
          fontSize: "12px",
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    legend: {
      show: true,
      position: "top",
      offsetY: -10,
      horizontalAlign: "right",
      floating: true,
      fontFamily: themeFont,
      labels: { colors: inverse2 },
    },
  };

  var themeColor2 = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var themeColorRgb2 = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme-rgb")
    .trim();
  var bodyBg2 = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const setupChart = (canvasRef, labels, data, themeColor, themeColorRgb, bodyBg) => {
    if (!canvasRef.current) return;
    return new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: gauserselectedOption.label,
            data,
            borderColor: themeColor,
            borderWidth: 1.5,
            pointBackgroundColor: bodyBg,
            pointBorderWidth: 1.5,
            pointRadius: 4,
            pointHoverBackgroundColor: themeColor,
            pointHoverBorderColor: bodyBg,
            pointHoverRadius: 7,
          },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    });
  };

  const setupeventChart = (canvasRef, labels, data, themeColor, themeColorRgb, bodyBg) => {
    if (!canvasRef.current) return;
    return new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: gaeventselectedOption.label,
            data,
            borderColor: themeColor,
            borderWidth: 1.5,
            pointBackgroundColor: bodyBg,
            pointBorderWidth: 1.5,
            pointRadius: 4,
            pointHoverBackgroundColor: themeColor,
            pointHoverBorderColor: bodyBg,
            pointHoverRadius: 7,
          },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    });
  };

  const setuppagescreenChart = (
    canvasRef,
    labels,
    data,
    themeColor,
    themeColorRgb,
    bodyBg
  ) => {
    if (!canvasRef.current) return;
    return new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: gapagescreenselectedOption.label,
            data,
            borderColor: themeColor,
            borderWidth: 1.5,
            pointBackgroundColor: bodyBg,
            pointBorderWidth: 1.5,
            pointRadius: 4,
            pointHoverBackgroundColor: themeColor,
            pointHoverBorderColor: bodyBg,
            pointHoverRadius: 7,
          },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    });
  };

  const setupsessionChart = (canvasRef, labels, data, themeColor, themeColorRgb, bodyBg) => {
    if (!canvasRef.current) return;
    return new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: gasessionselectedOption.label,
            data,
            borderColor: themeColor,
            borderWidth: 1.5,
            pointBackgroundColor: bodyBg,
            pointBorderWidth: 1.5,
            pointRadius: 4,
            pointHoverBackgroundColor: themeColor,
            pointHoverBorderColor: bodyBg,
            pointHoverRadius: 7,
          },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    });
  };

  useEffect(() => {
    const chartInstance = setupChart(
      mainChartRef,
      craftedlabels,
      craftedlinevalues,
      themeColor2,
      themeColorRgb2,
      bodyBg2
    );
    return () => chartInstance && chartInstance.destroy();
  }, [craftedlabels, craftedlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

  useEffect(() => {
    const chartInstance = setupeventChart(
      eventChartRef,
      eventlabels,
      eventlinevalues,
      themeColor2,
      themeColorRgb2,
      bodyBg2
    );
    return () => chartInstance && chartInstance.destroy();
  }, [eventlabels, eventlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

  useEffect(() => {
    const chartInstance = setuppagescreenChart(
      pagescreenChartRef,
      pagescreenlabels,
      pagescreenlinevalues,
      themeColor2,
      themeColorRgb2,
      bodyBg2
    );
    return () => chartInstance && chartInstance.destroy();
  }, [pagescreenlabels, pagescreenlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

  useEffect(() => {
    const chartInstance = setupsessionChart(
      sessionChartRef,
      sessionlabels,
      sessionlinevalues,
      themeColor2,
      themeColorRgb2,
      bodyBg2
    );
    return () => chartInstance && chartInstance.destroy();
  }, [sessionlabels, sessionlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

  // ========= unchanged Expand components below =========
  // (kept exactly as you provided — no loader overlays in expand modals)

  const GAUserExpand = () => {
    const expandChartRef = useRef(null);

    useEffect(() => {
      const chartInstance = setupChart(
        expandChartRef,
        craftedlabels,
        craftedlinevalues,
        themeColor2,
        themeColorRgb2,
        bodyBg2
      );
      return () => chartInstance && chartInstance.destroy();
    }, [craftedlabels, craftedlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

    return (
      <>
        <h3>GA - USER - {gauserselectedOption.label}</h3>
        <div className="row">
          <h2 className="col-xl-3">{UserTile.totalMetricValue}</h2>
          <div className="col-md-2">
            <label htmlFor="date">Date</label>
            <Select
              options={GADateOptions}
              value={gauserselectedDateOption}
              onChange={handlegauserdateChange}
              classNamePrefix="react-select"
            />
            <div className="col-xl-9">
              {craftedcustomDateRange && (
                <>
                  <label>From:</label>
                  <DatePicker selected={craftedstartDate} className="form-control" />
                  <br></br>
                  <label>To:</label>
                  <DatePicker selected={craftedendDate} className="form-control" />
                </>
              )}
            </div>
          </div>

          <div className="col-md-2">
            <label htmlFor="age">User Options</label>
            <Select
              options={GAUserOptions}
              value={gauserselectedOption}
              onChange={handlegauserChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2 mt-3 pt-1">
            <button className="btn btn-secondary">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-lg-12 mb-1 mb-lg-0">
          <canvas ref={expandChartRef} className="w-100" height="700" />
        </div>
      </>
    );
  };

  const GAEventExpand = () => {
    const expandChartRef = useRef(null);

    useEffect(() => {
      const chartInstance = setupeventChart(
        expandChartRef,
        eventlabels,
        eventlinevalues,
        themeColor2,
        themeColorRgb2,
        bodyBg2
      );
      return () => chartInstance && chartInstance.destroy();
    }, [eventlabels, eventlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

    return (
      <>
        <h3>GA - Event - {gaeventselectedOption.label}</h3>
        <div className="row">
          <h2 className="col-xl-3">
            {EventTile && EventTile.totalMetricValue ? EventTile.totalMetricValue : 0}
          </h2>
          <div className="col-md-2">
            <label htmlFor="date">Date</label>
            <Select
              options={GADateOptions}
              value={gaeventselectedDateOption}
              onChange={handlegaeventdateChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="age">Event Options</label>
            <Select
              options={GAEventOptions}
              value={gaeventselectedOption}
              onChange={handlegaeventChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2 mt-3 pt-1">
            <button className="btn btn-secondary">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        <div className="col-lg-12 mb-1 mb-lg-0">
          <canvas ref={expandChartRef} className="w-100" height="700" />
        </div>
      </>
    );
  };

  const GAPageScreenExpand = () => {
    const expandChartRef = useRef(null);

    useEffect(() => {
      const chartInstance = setuppagescreenChart(
        expandChartRef,
        pagescreenlabels,
        pagescreenlinevalues,
        themeColor2,
        themeColorRgb2,
        bodyBg2
      );
      return () => chartInstance && chartInstance.destroy();
    }, [pagescreenlabels, pagescreenlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

    return (
      <>
        <h3>GA - Page/Screen - {gapagescreenselectedOption.label}</h3>
        <div className="row">
          <h2 className="col-xl-3">
            {PageScreenTile && PageScreenTile.totalMetricValue
              ? PageScreenTile.totalMetricValue
              : 0}
          </h2>
          <div className="col-md-2">
            <label htmlFor="date">Date</label>
            <Select
              options={GADateOptions}
              value={gapagescreenselectedDateOption}
              onChange={handlegapagescreendateChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="age">Page/Screen Options</label>
            <Select
              options={GAPageScreenOptions}
              value={gapagescreenselectedOption}
              onChange={handlegapagescreenChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2 mt-3 pt-1">
            <button className="btn btn-secondary">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        <div className="col-lg-12 mb-1 mb-lg-0">
          <canvas ref={expandChartRef} className="w-100" height="700" />
        </div>
      </>
    );
  };

  const GASessionExpand = () => {
    const expandChartRef = useRef(null);

    useEffect(() => {
      const chartInstance = setupsessionChart(
        expandChartRef,
        sessionlabels,
        sessionlinevalues,
        themeColor2,
        themeColorRgb2,
        bodyBg2
      );
      return () => chartInstance && chartInstance.destroy();
    }, [sessionlabels, sessionlinevalues, themeColor2, themeColorRgb2, bodyBg2]);

    return (
      <>
        <h3>GA - Session - {gasessionselectedOption.label}</h3>
        <div className="row">
          <h2 className="col-xl-3">
            {SessionTile && SessionTile.totalMetricValue
              ? SessionTile.totalMetricValue
              : 0}
          </h2>
          <div className="col-md-2">
            <label htmlFor="date">Date</label>
            <Select
              options={GADateOptions}
              value={gasessionselectedDateOption}
              onChange={handlegasessiondateChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="age">Session Options</label>
            <Select
              options={GASessionOptions}
              value={gasessionselectedOption}
              onChange={handlegasessionChange}
              classNamePrefix="react-select"
            />
          </div>

          <div className="col-md-2 mt-3 pt-1">
            <button className="btn btn-secondary">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        <div className="col-lg-12 mb-1 mb-lg-0">
          <canvas ref={expandChartRef} className="w-100" height="700" />
        </div>
      </>
    );
  };

  function sortDataByDateDescending(dailyData) {
    return (dailyData || []).sort((a, b) => {
      const dateA = new Date(a.dimensionValues[0].value.split("-").reverse().join("-"));
      const dateB = new Date(b.dimensionValues[0].value.split("-").reverse().join("-"));
      return dateA - dateB;
    });
  }

  // =========================================================
  // FETCHES + LOADER FLAGS (only for the effects you have enabled)
  // =========================================================

  useEffect(() => {
    let mounted = true;
    let inFlight = false;

    const UserTileInfo = async () => {
      if (inFlight) return;
      inFlight = true;

      const isRefresh = userHasLoaded.current === true;

      try {
        if (!isRefresh) setLoadingUser(true);
        else setRefreshingUser(true);

        let startDate = gauserselectedDateOption.value;
        let endDate = "today";
        let dimension = "date";
        let metric = gauserselectedOption.value;
        const token = localStorage.getItem("jwtToken");

        const response = await fetch(
          `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/firebasehome/analytics/users?startDate=${startDate}&endDate=${endDate}&dimension=${dimension}&metric=${metric}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        if (!mounted) return;

        const sortedData = sortDataByDateDescending(result.dailyData);
        setDataUserTile({
          dailyData: sortedData,
          totalMetricValue: result.totalMetricValue,
        });

        userHasLoaded.current = true;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (!mounted) return;
        setLoadingUser(false);
        setRefreshingUser(false);
        inFlight = false;
      }
    };

    UserTileInfo();
    return () => {
      mounted = false;
    };
  }, [gauserselectedOption, gauserselectedDateOption]);

  useEffect(() => {
    let mounted = true;
    let inFlight = false;

    const EventTileInfo = async () => {
      if (inFlight) return;
      inFlight = true;

      const isRefresh = eventHasLoaded.current === true;

      try {
        if (!isRefresh) setLoadingEvent(true);
        else setRefreshingEvent(true);

        let startDate = gaeventselectedDateOption.value;
        let endDate = "today";
        let dimension = "date";
        let metric = gaeventselectedOption.value;
        const token = localStorage.getItem("jwtToken");

        const response = await fetch(
          `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/firebasehome/analytics/event?startDate=${startDate}&endDate=${endDate}&dimension=${dimension}&metric=${metric}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        if (!mounted) return;

        const sortedData = sortDataByDateDescending(result.dailyData);
        setDataEventTile({
          dailyData: sortedData,
          totalMetricValue: result.totalMetricValue,
        });

        eventHasLoaded.current = true;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (!mounted) return;
        setLoadingEvent(false);
        setRefreshingEvent(false);
        inFlight = false;
      }
    };

    EventTileInfo();
    return () => {
      mounted = false;
    };
  }, [gaeventselectedOption, gaeventselectedDateOption]);

  useEffect(() => {
    let mounted = true;
    let inFlight = false;

    const PageScreenTileInfo = async () => {
      if (inFlight) return;
      inFlight = true;

      const isRefresh = pagescreenHasLoaded.current === true;

      try {
        if (!isRefresh) setLoadingPageScreen(true);
        else setRefreshingPageScreen(true);

        let startDate = gapagescreenselectedDateOption.value;
        let endDate = "today";
        let dimension = "date";
        let metric = gapagescreenselectedOption.value;
        const token = localStorage.getItem("jwtToken");

        const response = await fetch(
          `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/firebasehome/analytics/pagescreen?startDate=${startDate}&endDate=${endDate}&dimension=${dimension}&metric=${metric}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        if (!mounted) return;

        const sortedData = sortDataByDateDescending(result.dailyData);
        setDataPageScreenTile({
          dailyData: sortedData,
          totalMetricValue: result.totalMetricValue,
        });

        pagescreenHasLoaded.current = true;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (!mounted) return;
        setLoadingPageScreen(false);
        setRefreshingPageScreen(false);
        inFlight = false;
      }
    };

    PageScreenTileInfo();
    return () => {
      mounted = false;
    };
  }, [gapagescreenselectedOption, gapagescreenselectedDateOption]);

  useEffect(() => {
    let mounted = true;
    let inFlight = false;

    const SessionTileInfo = async () => {
      if (inFlight) return;
      inFlight = true;

      const isRefresh = sessionHasLoaded.current === true;

      try {
        if (!isRefresh) setLoadingSession(true);
        else setRefreshingSession(true);

        let startDate = gasessionselectedDateOption.value;
        let endDate = "today";
        let dimension = "date";
        let metric = gasessionselectedOption.value;
        const token = localStorage.getItem("jwtToken");

        const response = await fetch(
          `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/firebasehome/analytics/sessions?startDate=${startDate}&endDate=${endDate}&dimension=${dimension}&metric=${metric}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        if (!mounted) return;

        const sortedData = sortDataByDateDescending(result.dailyData);
        setDataSessionTile({
          dailyData: sortedData,
          totalMetricValue: result.totalMetricValue,
        });

        sessionHasLoaded.current = true;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (!mounted) return;
        setLoadingSession(false);
        setRefreshingSession(false);
        inFlight = false;
      }
    };

    SessionTileInfo();
    return () => {
      mounted = false;
    };
  }, [gasessionselectedOption, gasessionselectedDateOption]);

  return (
    <>
      <div className="row mb-3">
        <div className="col-xl-12 col-lg-12">
          <h6>
            <span style={{ color: themeColor }}>PAGES</span> / FIREBASE ANALYTICS
          </h6>
          <h2>HOME</h2>
        </div>
      </div>

      <div className="row">
        {/* User */}
        <div className="col-xl-6 col-lg-12">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <h4 className="flex-grow-1">Users</h4>
                <ModalComponent cardBodyContent={<GAUserExpand />} />
              </div>

              <div className="row align-items-center mb-2">
                <div className="col-6 text-right mb-1">
                  <h4 className="mb-0">
                    {UserTile && UserTile.totalMetricValue ? UserTile.totalMetricValue : 0}
                  </h4>
                </div>
                <div className="col-6 text-end mt-2">
                  <h5 className="mb-0" style={{ color: "#3CD25D" }}></h5>
                  <p className="mb-0">{gauserselectedOption.label}</p>
                </div>
              </div>

              <div className="ratio ratio-21x9 mb-4" style={{ position: "relative" }}>
                <canvas ref={mainChartRef} />
                {loadingUser ? (
                  <div style={overlayStyle}>
                    <InlineSpinner />
                  </div>
                ) : craftedlinevalues.length === 0 ? (
                  <div style={overlayStyle}>
                    <NoData text="No user data yet" />
                  </div>
                ) : null}
              </div>

              <div className="mt-4 pb-4">
                <div
                  style={{
                    height: 18,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {refreshingUser ? <RefreshNote /> : <div />}
                </div>
                {/* <i className="fas fa-angle-up"></i> */}
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Event */}
        <div className="col-xl-6 col-lg-12">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <h4 className="flex-grow-1">Events</h4>
                <ModalComponent cardBodyContent={<GAEventExpand />} />
              </div>

              <div className="row align-items-center mb-2">
                <div className="col-6 text-right mb-1">
                  <h4 className="mb-0">
                    {EventTile && EventTile.totalMetricValue ? EventTile.totalMetricValue : 0}
                  </h4>
                </div>
                <div className="col-6 text-end mt-2">
                  <h5 className="mb-0" style={{ color: "#3CD25D" }}></h5>
                  <p className="mb-0">{gaeventselectedOption.label}</p>
                </div>
              </div>

              <div className="ratio ratio-21x9 mb-4" style={{ position: "relative" }}>
                <canvas ref={eventChartRef} />
                {loadingEvent ? (
                  <div style={overlayStyle}>
                    <InlineSpinner />
                  </div>
                ) : eventlinevalues.length === 0 ? (
                  <div style={overlayStyle}>
                    <NoData text="No event data yet" />
                  </div>
                ) : null}
              </div>

              <div className="mt-4 pb-4">
                <div
                  style={{
                    height: 18,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {refreshingEvent ? <RefreshNote /> : <div />}
                </div>
                {/* <i className="fas fa-angle-up"></i> */}
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Page/Screen */}
        <div className="col-xl-6 col-lg-12">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <h4 className="flex-grow-1">Page/Screen</h4>
                <ModalComponent cardBodyContent={<GAPageScreenExpand />} />
              </div>

              <div className="row align-items-center mb-2">
                <div className="col-6 text-right mb-1">
                  <h4 className="mb-0">
                    {PageScreenTile && PageScreenTile.totalMetricValue
                      ? PageScreenTile.totalMetricValue
                      : 0}
                  </h4>
                </div>
                <div className="col-6 text-end mt-2">
                  <h5 className="mb-0" style={{ color: "#3CD25D" }}></h5>
                  <p className="mb-0">{gapagescreenselectedOption.label}</p>
                </div>
              </div>

              <div className="ratio ratio-21x9 mb-4" style={{ position: "relative" }}>
                <canvas ref={pagescreenChartRef} />
                {loadingPageScreen ? (
                  <div style={overlayStyle}>
                    <InlineSpinner />
                  </div>
                ) : pagescreenlinevalues.length === 0 ? (
                  <div style={overlayStyle}>
                    <NoData text="No page/screen data yet" />
                  </div>
                ) : null}
              </div>

              <div className="mt-4 pb-4">
                <div
                  style={{
                    height: 18,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {refreshingPageScreen ? <RefreshNote /> : <div />}
                </div>
                {/* <i className="fas fa-angle-up"></i> */}
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Session */}
        <div className="col-xl-6 col-lg-12">
          <Card className="mb-3">
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <h4 className="flex-grow-1">Sessions</h4>
                <ModalComponent cardBodyContent={<GASessionExpand />} />
              </div>

              <div className="row align-items-center mb-2">
                <div className="col-6 text-right mb-1">
                  <h4 className="mb-0">
                    {SessionTile && SessionTile.totalMetricValue ? SessionTile.totalMetricValue : 0}
                  </h4>
                </div>
                <div className="col-6 text-end mt-2">
                  <h5 className="mb-0" style={{ color: "#3CD25D" }}></h5>
                  <p className="mb-0">{gasessionselectedOption.label}</p>
                </div>
              </div>

              <div className="ratio ratio-21x9 mb-4" style={{ position: "relative" }}>
                <canvas ref={sessionChartRef} />
                {loadingSession ? (
                  <div style={overlayStyle}>
                    <InlineSpinner />
                  </div>
                ) : sessionlinevalues.length === 0 ? (
                  <div style={overlayStyle}>
                    <NoData text="No session data yet" />
                  </div>
                ) : null}
              </div>

              <div className="mt-4 pb-4">
                <div
                  style={{
                    height: 18,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {refreshingSession ? <RefreshNote /> : <div />}
                </div>
                {/* <i className="fas fa-angle-up"></i> */}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Firebasehome;
